import { normaliseListingExtrasKeys } from './suggestedPaidExtrasFromListingExtras';

/**
 * Orden en que la tarjeta de anuncio elige qué extras enseña ("Barbacoa, nevera, zona
 * techada"). Primero los raros y llamativos, que solo tienen unos pocos anuncios; luego los
 * comunes, en el orden del diseño. Las claves son las opciones del campo `extras` de Console
 * (muestra de 100 anuncios publicados, oct-2026: Barbecue 94 %, techada 79 %, Refrigerator 70 %).
 * Un extra que no esté aquí no sale en la tarjeta.
 */
export const CARD_EXTRAS_PRIORITY = [
  'jacuzzi',
  'heated',
  'piscina_interior',
  'sauna',
  'tobogan',
  'cama_balinesa',
  'Barbecue',
  'Refrigerator',
  'techada',
  'cocina',
  'chillout',
  'barra',
  'pingpong',
  'Wifi',
];

// Las etiquetas de Console empiezan por un emoji ("🍖 Barbacoa"): fuera todo lo que no sea
// letra o número al principio.
const stripLeadingSymbols = label =>
  String(label)
    .replace(/^[^\p{L}\p{N}]+/u, '')
    .trim();

/**
 * Línea de equipamiento de la tarjeta: hasta `max` extras del anuncio, por prioridad, con su
 * etiqueta de Console sin emoji y en minúscula salvo la primera. `null` si no queda ninguno.
 *
 * @param {Array|String} extras `publicData.extras`
 * @param {Object} extrasFieldConfig el campo `extras` de `config.listing.listingFields`
 * @param {Number} max cuántos enseñar
 */
export const cardExtrasLine = (extras, extrasFieldConfig, max = 3) => {
  const keys = new Set(normaliseListingExtrasKeys(extras));
  const labelFor = new Map(
    (extrasFieldConfig?.enumOptions || []).map(({ option, label }) => [
      String(option),
      stripLeadingSymbols(label),
    ])
  );
  const labels = CARD_EXTRAS_PRIORITY.filter(key => keys.has(key) && labelFor.get(key))
    .slice(0, max)
    .map((key, i) => {
      const label = labelFor.get(key);
      return i === 0 ? label : label.charAt(0).toLowerCase() + label.slice(1);
    });
  return labels.length > 0 ? labels.join(', ') : null;
};
